export const loginApi = "user/login";
export const signupApi = "users";
export const bookings = "bookings";
export const userprofile = "users";
export const feedback = "feedback";
export const customer_support = "customer_supports";
export const APPID="1444117527506694"
